
interface IProps {
	type: string,
	target: string,
};

function Callout({type, target} : IProps) {
	const renderCallouts = () => {
		const targetCallout = document.getElementById(target) as HTMLElement;
		const content = targetCallout?.innerHTML;
		return {
			__html: content,
		}
	}
	return (
		<div
			className={`schedule-callout ${
				type === "desktop" ? "schedule-callout--desktop" : ""
			}`} dangerouslySetInnerHTML={renderCallouts()}
		/>
	);
}
export default Callout;
